module.exports = __webpack_public_path__ + "img/collect_ny_icon_nor@2x.ffab0c0f.png";